import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: FullScreenLoadingState = {
    isLoading: false,
};

export const fullScreenLoadingSlice = createSlice({
    name: 'full-screen-loading',
    initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});

export interface FullScreenLoadingState {
    isLoading: boolean;
}

export const fullScreenLoadingAction = fullScreenLoadingSlice.actions;

export default fullScreenLoadingSlice.reducer;
